'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');
var title = 'Gun Free Funds';
var description = 'Get your money out of gun stocks. Gun Free Funds is a search platform that informs and empowers everyday investors.';
var domain = process.env.DOMAIN || 'https://gunfreefunds.org';
// if were not the client (window) use the injected config otherwise create it
var Version = require('./data/Version.json');
var FootprintRanges = require('./data/FootprintRanges.json');
var TargetDateSeries = require('./data/TargetDateSeries.json');
var CoreBenchmarks = require('./data/CoreBenchmarks.json');
var ExtendedBenchmarks = require('./data/ExtendedBenchmarks.json');
var FamilyFunds = require('./data/FamilyFunds.json');
var FundCategoryAll = require('./data/FundCategoryAll.json');
var FundFamilyAll = require('./data/FundFamilyAll.json');
var GefScoreNormalizersAllScored = require('./data/GefScoreNormalizersAllScored.json');
var GefScoreNormalizersGroups = require('./data/GefScoreNormalizersGroups.json');
var GefScoreNormalizersPeers = require('./data/GefScoreNormalizersPeers.json');
var Changelog = require('./data/Changelog.json');
var config = {
    host: process.env.HOST || 'localhost',
    port: process.env.PORT || 3000,
    version: Version['version'],
    description: description,
    domain: domain,
    loggingOff: process.env.LOGGING_OFF,
    httpsRedirect: process.env.HTTPS_REDIRECT,
    gaKey: process.env.GA_KEY,
    apiHost: process.env.APIHOST || 'https://api.fossilfreefunds.org',
    apiPort: process.env.APIPORT || 443,
    imageSocialShare: 'iyv-gff-social-share-201908.jpg',
    shareMessage: title,
    queryMaxFunds: 10,
    changelog: Changelog,
    gefScoreNormalizers: {
        overall: 22,
        balance: 15,
        policies: 7,
        allScored: GefScoreNormalizersAllScored['all_scored'],
        groups: GefScoreNormalizersGroups,
        peers: GefScoreNormalizersPeers
    },
    signupForm: {
        url: 'https://go.asyousow.org/l/344561/2019-08-08/j5d59s',
        id: '344561_61827pi_344561_61827'
    },
    getStartedInput: {
        label: 'Top-scoring funds',
        title: 'Top-scoring funds | Gun Free Funds',
        faclass: null
    },
    socialAppId: '1094061130685792',
    profilePath: 'gun-investments',
    routes: {
        home: '/',
        about: '/about',
        howitworks: '/how-it-works',
        toolkit: '/action-toolkit',
        media: '/media',
        list: '/funds',
        compare: '/compare',
        clean: '/funds?dsc=false&srt=grade_guns',
        fund: '/fund',
        targetdate: '/target-date-funds',
        targetDateFunds: '/target-date-funds',
        families: '/families',
        legal: '/legal',
        indexfunds: '/index-funds',
        notFound: '/not-found-404',
        companies: '/companies'
    },
    links: {
        changelog: 'https://iyv-charts.s3-us-west-2.amazonaws.com/files/',
        donate: 'https://connect.clickandpledge.com/w/Form/9d5e83e2-b2d9-43eb-9834-043d7558b785',
        contact: 'https://www.asyousow.org/contact',
        signup: 'https://go.asyousow.org/sign-up-gun-free-funds',
        contactJill: 'mailto:jcourtenay*asyousow.org?subject=Weapon%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
        contactAndrew: 'mailto:amontes*asyousow.org?subject=Weapon%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
        ays: 'http://www.asyousow.org',
        aysabout: 'http://www.asyousow.org/about-us',
        ceres: 'http://www.ceres.org/investor-network/resolutions#!/subject=&year=&company=&filer=&sector=&status=&memo=&all=&=',
        fff: 'https://fossilfreefunds.org',
        dff: 'https://deforestationfreefunds.org',
        gef: 'https://genderequalityfunds.org',
        wff: 'https://weaponfreefunds.org',
        gff: 'https://gunfreefunds.org',
        tff: 'https://tobaccofreefunds.org',
        pff: 'https://prisonfreefunds.org',
        iyv: 'https://investyourvalues.org',
        compareFeedback: 'https://forms.gle/cdJG5C7WoGxKkEx78',
        aysinvest: 'https://www.asyousow.org/invest-your-values/',
        aysvoteshares: 'http://www.asyousow.org/about-us/vote-your-shares/',
        pledge: 'http://www.divestfromwarmachine.org/take_the_pledge',
        dfw: 'http://www.divestfromwarmachine.org/',
        codepink: 'https://www.codepink.org/',
        morningstar: 'https://www.morningstar.com/',
        dffFund: 'https://deforestationfreefunds.org/fund',
        fffFund: 'https://fossilfreefunds.org/funds',
        wffFund: 'https://weaponfreefunds.org/funds',
        socialAYSfb: 'https://www.facebook.com/asyousow.org/',
        socialAYStwitter: 'https://twitter.com/asyousow',
        socialAYSinstagram: 'https://www.instagram.com/_asyousow_/',
        socialDFWfb: 'https://www.facebook.com/codepinkalert',
        socialDFWtwitter: 'https://twitter.com/codepink',
        socialDFWinstagram: 'https://www.instagram.com/codepinkalert/',
        ussifperf: 'https://www.ussif.org/performance',
        ussif: 'https://www.ussif.org/',
        dontbank: 'https://www.dontbankonthebomb.com/',
        dfwguides: 'http://www.divestfromwarmachine.org/guides'
    },
    fundFields: {
        ALL_COUNT: 'wff_all_count',
        MIL_COUNT: 'wff_mil_count',
        CIV_COUNT: 'wff_civ_count',
        ALL_ASSET: 'wff_all_asset',
        MIL_ASSET: 'wff_mil_asset',
        CIV_ASSET: 'wff_civ_asset',
        ALL_WEIGHT: 'wff_all_weight',
        MIL_WEIGHT: 'wff_mil_weight',
        CIV_WEIGHT: 'wff_civ_weight',
        ALL_RATING: 'grade_weapons',
        MIL_RATING: 'grade_military',
        CIV_RATING: 'grade_guns'
    },
    // footprint date IF NEEDED
    footprintDate: 'Jun. 2020',
    // for footprint scoring
    footprintRanges: FootprintRanges,
    coreBenchmarks: CoreBenchmarks,
    extendedBenchmarks: ExtendedBenchmarks,
    // asset managers for Family view
    familyFunds: FamilyFunds,
    // target dates
    targetDateSeries: TargetDateSeries,
    engagementFunds: [],
    /*ignore jslint start*/
    formOptions: {
        market: [{ name: 'All funds', value: 'Show all funds' }, { name: 'United States', value: 'US' }],
        type: [{ name: 'All funds', value: 'All funds' }, { name: 'Open-end funds', value: 'FO' }, { name: 'Exchange-traded funds (ETFs)', value: 'FE' }, { name: 'Common/Collective trusts', value: 'TSP' }, { name: 'Variable annuities', value: 'VA' }],
        diversified: [{ name: 'All funds', value: false }, { name: 'Diversified', value: 'false' }, { name: 'Non-diversified', value: 'true' }],
        sri: [{ name: 'All funds', value: false }, { name: 'Sustainability mandate', value: '1' }],
        fundUssif: [{ name: 'All funds', value: false }, { name: 'US-SIF funds', value: '1.5' }],
        targetDate: [{ name: 'All funds', value: false }, { name: 'Target date funds', value: '1' }],
        fundPerformance: [{ name: 'All funds', value: false }, { name: 'Positive 1-year returns', value: 'trailing_return_y1' }, { name: 'Positive 3-year returns', value: 'trailing_return_y3' }, { name: 'Positive 5-year returns', value: 'trailing_return_y5' }, { name: 'Positive 10-year returns', value: 'trailing_return_y10' }, { name: 'Positive 15-year returns', value: 'trailing_return_y15' }, { name: 'Positive 20-year returns', value: 'trailing_return_y20' }],
        fffGrade: [{ name: 'All funds', value: false }, { name: 'Fossil fuel grade A', value: 1 }, { name: 'Fossil fuel grade B or higher', value: 2 }, { name: 'Fossil fuel grade C or higher', value: 3 }, { name: 'Fossil fuel grade D or higher', value: 4 }],
        ffbGrade: [{ name: 'All funds', value: false }, { name: 'Fossil finance grade A', value: 1 }, { name: 'Fossil finance grade B or higher', value: 2 }, { name: 'Fossil finance grade C or higher', value: 3 }, { name: 'Fossil finance grade D or higher', value: 4 }],
        ffiGrade: [{ name: 'All funds', value: false }, { name: 'Fossil insurance grade A', value: 1 }, { name: 'Fossil insurance grade B or higher', value: 2 }, { name: 'Fossil insurance grade C or higher', value: 3 }, { name: 'Fossil insurance grade D or higher', value: 4 }],
        dffGrade: [{ name: 'All funds', value: false }, { name: 'Deforestation grade A', value: 1 }, { name: 'Deforestation grade Engagement or higher', value: 1.5 }, { name: 'Deforestation grade B or higher', value: 2 }, { name: 'Deforestation grade C or higher', value: 3 }, { name: 'Deforestation grade D or higher', value: 4 }],
        gefGrade: [{ name: 'All funds', value: false }, { name: 'Gender equality grade A', value: 1 }, { name: 'Gender equality grade B or higher', value: 2 }, { name: 'Gender equality grade C or higher', value: 3 }, { name: 'Gender equality grade D or higher', value: 4 }],
        wffGrade: [{ name: 'All funds', value: false }, { name: 'Weapon grade A', value: 1 }, { name: 'Weapon grade B or higher', value: 2 }, { name: 'Weapon grade C or higher', value: 3 }, { name: 'Weapon grade D or higher', value: 4 }],
        gffGrade: [{ name: 'All funds', value: false }, { name: 'Civilian firearm grade A', value: 1 }, { name: 'Civilian firearm grade B or higher', value: 2 }, { name: 'Civilian firearm grade C or higher', value: 3 }, { name: 'Civilian firearm grade D or higher', value: 4 }],
        tffGrade: [{ name: 'All funds', value: false }, { name: 'Tobacco grade A', value: 1 }, { name: 'Tobacco grade Engagement or higher', value: 1.5 }, { name: 'Tobacco grade B or higher', value: 2 }, { name: 'Tobacco grade C or higher', value: 3 }, { name: 'Tobacco grade D or higher', value: 4 }],
        pffGrade: [{ name: 'All funds', value: false }, { name: 'Prison industrial complex grade A', value: 1 }, { name: 'Prison industrial complex grade B or higher', value: 2 }, { name: 'Prison industrial complex grade C or higher', value: 3 }, { name: 'Prison industrial complex grade D or higher', value: 4 }],
        clean: [{ name: 'All funds', value: false }, { name: 'A grade funds only', value: 'true' }],
        currency: [],
        currencyAll: [{ name: 'All funds' }, { name: 'US Dollar' }],
        currencyUS: [
            //
        ],
        currencyUK: [
            //
        ],
        currencyHK: [
            //
        ],
        currencyDK: [
            //
        ],
        currencyFR: [
            //
        ],
        currencyDE: [
            //
        ],
        fundGroup: [],
        fundGroupAll: [{ name: 'All funds' }, { name: 'Allocation Funds' }, { name: 'International Equity Funds' }, { name: 'Sector Equity Funds' }, { name: 'U.S. Equity Fund' }],
        fundGroupUS: [
            //
        ],
        fundGroupUK: [
            //
        ],
        fundGroupHK: [
            //
        ],
        fundGroupDK: [
            //
        ],
        fundGroupFR: [
            //
        ],
        fundGroupDE: [
            //
        ],
        fundCategory: [],
        fundCategoryAll: FundCategoryAll,
        fundCategoryUS: [
            //
        ],
        fundCategoryUK: [
            //
        ],
        fundCategoryHK: [
            //
        ],
        fundCategoryDK: [
            //
        ],
        fundCategoryFR: [
            //
        ],
        fundCategoryDE: [
            //
        ],
        fundFamily: [],
        fundFamilyAll: FundFamilyAll,
        fundFamilyUS: [
            //
        ],
        fundFamilyUK: [
            //
        ],
        fundFamilyHK: [
            //
        ],
        fundFamilyDK: [
            //
        ],
        fundFamilyFR: [
            //
        ],
        fundFamilyDE: [
            //
        ]
    },
    /*ignore jslint end*/

    app: {
        title: title,
        description: description,
        head: {
            defaultTitle: title,
            titleTemplate: '%s | ' + title,
            meta: [{ name: 'description', content: description }, { charset: 'utf-8' },
            // twitter
            { property: 'twitter:card', content: 'summary_large_image' }, { property: 'twitter:site', content: '@asyousow' }, { property: 'twitter:title', content: title }, { property: 'twitter:description', content: description }, { property: 'twitter:creator', content: '@asyousow' }, { property: 'twitter:image', content: '' },
            // {property: 'twitter:image', content: ''},

            // og
            { property: 'og:site_name', content: title }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: domain }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: '' }]
        }
    }
};
// inject the serverconfig if its on the browser
if (typeof window !== 'undefined') {
    config = (0, _assign2.default)({}, config, window.__serverConfig);
}
module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 10
// module chunks = 0